import * as types from './../types/home';

const INITIAL_STATE = {
  loading: false,
  home: {}

};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_HOME:
      return { ...state, home: action.payload };

    case types.LOADING_HOME:
      return { ...state, loading: action.payload };

    default:
      return state;
  }
};